/**
 * Accented characters that can extend beyond mask bounds in SplitText animation.
 * Used to detect when to bypass SplitText masking animation to prevent clipping.
 */
export const ACCENTED_CHARACTERS = [
  'á', 'é', 'í', 'ó', 'ú', 'ý', // Acute accent
  'à', 'è', 'ì', 'ò', 'ù', // Grave accent
  'â', 'ê', 'î', 'ô', 'û', // Circumflex
  'ä', 'ë', 'ï', 'ö', 'ü', 'ÿ', // Diaeresis/umlaut
  'ã', 'ñ', 'õ', // Tilde
  'å', 'ů', // Ring above
  'ā', 'ē', 'ī', 'ō', 'ū', // Macron
  'ç', // Cedilla
  'Á', 'É', 'Í', 'Ó', 'Ú', 'Ý', // Uppercase acute
  'À', 'È', 'Ì', 'Ò', 'Ù', // Uppercase grave
  'Â', 'Ê', 'Î', 'Ô', 'Û', // Uppercase circumflex
  'Ä', 'Ë', 'Ï', 'Ö', 'Ü', 'Ÿ', // Uppercase diaeresis
  'Ã', 'Ñ', 'Õ', // Uppercase tilde
  'Å', 'Ů', // Uppercase ring
  'Ā', 'Ē', 'Ī', 'Ō', 'Ū', // Uppercase macron
  'Ç', // Uppercase cedilla
];

/**
 * Check if text contains accented characters that would extend beyond SplitText mask bounds
 */
export const hasAccentedCharacters = (text: string): boolean => {
  return ACCENTED_CHARACTERS.some(char => text.includes(char));
};
